import { useState } from 'react';

import { Api } from '../../api/api';

import type { RegisterState } from './RegisterState';
import { canSubmit } from './RegisterState';

/** Mirrors android/…/Screens/Register/RegisterViewModel.kt. */
export function useRegister(onRegistered: (email: string) => void) {
  const [state, setState] = useState<RegisterState>({
    email: '',
    password: '',
    passwordConfirmation: '',
    displayName: '',
    isSubmitting: false,
    error: null,
  });

  return {
    state,
    email: (email: string): void => setState((current) => ({ ...current, email, error: null })),
    password: (password: string): void => setState((current) => ({ ...current, password, error: null })),
    passwordConfirmation: (passwordConfirmation: string): void =>
      setState((current) => ({ ...current, passwordConfirmation, error: null })),
    displayName: (displayName: string): void => setState((current) => ({ ...current, displayName })),

    submit: async (): Promise<void> => {
      if (!canSubmit(state)) return;

      setState((current) => ({ ...current, isSubmitting: true, error: null }));

      const email: string = state.email.trim();
      const result = await Api.register({
        email,
        password: state.password,
        displayName: state.displayName.trim().length > 0 ? state.displayName.trim() : null,
      });

      if (result.ok) {
        // No session comes back and none should: the API answers the same way whether or not the address
        // was taken, so handing out a session here would hand it to whoever typed someone else's address
        // (R0031). The parent signs in next.
        setState((current) => ({ ...current, isSubmitting: false }));
        onRegistered(email);

        return;
      }

      // The API's message is rendered as it came: it explains what is wrong with the address or the
      // password, in reviewed wording (BR-13).
      setState((current) => ({ ...current, isSubmitting: false, error: result.error.message }));
    },
  };
}
